module.exports = __webpack_public_path__ + "media/images/lb/814-c3a08ec9fe6659cbdbfd414303eff665.svg";